require('./priority-common');
require('./modules/ecommerce');
require('./modules/util');
require('./modules/ecommerceGTag');
require('./modules/components/calendar/calendar');
require('./modules/components/calendar/calendar-prices');
require('./modules/components/subproducts-list/subproducts-selection');
require('./modules/components/subproducts-list/subproducts-prices');
require('./modules/components/subproducts-list/subproducts-privacy-switcher');
require('./modules/components/subproducts-list/helpers');
require('./modules/components/service-form/service-form');
